// extracted by mini-css-extract-plugin
export default {"events":"events_events__h98E2","events__title":"events_events__title__yW-w4"};